import { z } from 'zod';

import { DefinitionItem } from './language';

export const Job = z.object({
  id: z.string().default(''),
  name: z.string().default(''),
  enabled: z.boolean().default(false),
  createdAt: z.string().default(''),
  updatedAt: z.string().default(''),
  defaultEpmMasterFunctionality: z.object({ id: z.string(), name: z.string() }).nullable().default(null),
  definitions: z.array(DefinitionItem).default([]),
});
export type JobType = z.infer<typeof Job>;
